module.exports = __webpack_public_path__ + "static/img/5.616504e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/sp/5.png
// module id = g7Dn
// module chunks = 0